import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

const studioResource = (slug: string) => `/public/studio/${encodeURIComponent(slug)}`;

export interface PublicStudioReviewSummary {
  average: number;
  count: number;
}

export interface PublicStudioMetadata {
  is_powered_by_adatis: boolean;
  review_summary?: PublicStudioReviewSummary | null;
}

export interface PublicStudioPrimaryUnit {
  id: number;
  name: string;
  country_code: string;
  phone_number: string;
  google_review_url: string | null;
}

export interface PublicStudioServiceCategory {
  name: string;
}

export interface PublicStudioService {
  id: number;
  name: string;
  description?: string | null;
  duration_minutes: number;
  price_cents: number;
  list_price_cents?: number;
  list_price_display?: string;
  promo_active?: boolean;
  price_is_from?: boolean;
  price_display: string;
  cover_url: string | null;
  category?: PublicStudioServiceCategory;
}

export interface PublicStudioProfessional {
  id: number;
  name: string;
  color_hex: string;
  photo_url: string | null;
  public_bio: string | null;
}

export interface PublicStudioClubPlanPreview {
  id: number;
  name: string;
  price: number;
  monthly_visit_limit?: number | null;
}

export interface PublicStudioClubTeaser {
  has_plans: boolean;
  plans_url: string | null;
  join_url: string | null;
  plans_preview?: PublicStudioClubPlanPreview[];
}

export interface PublicStudioProfile {
  name: string;
  logo_url: string | null;
  about_text: string | null;
  instagram_url: string | null;
  booking_token: string;
  club_teaser?: PublicStudioClubTeaser | null;
  primary_unit: PublicStudioPrimaryUnit | null;
  professionals: PublicStudioProfessional[];
  services: PublicStudioService[];
}

export interface PublicStudioResponse extends ApiResponse<PublicStudioProfile> {
  _metadata?: PublicStudioMetadata;
}

export const getPublicStudioProfile = (slug: string): Promise<PublicStudioResponse> =>
  api.get<PublicStudioResponse>(studioResource(slug));
